import { Button } from "@adfenix/alexandria";
import styled from "styled-components";
import { L80, L96 } from "@adfenix/alexandria";
// @todo REMOVE Level
import { Level } from "react-bulma-components";

export const Li = styled.li`
  list-style-type: disc;
  color: ${({ theme }) => theme.colors.black};
`;

export const StyledLinkButton = styled(Button)`
  padding: 0;
`;
export const StyledLevel = styled(Level)`
  display: inline-block;
  width: max-content;
  // Vertically center the radio buttons.
  .is-checkradio[type="radio"] + label::after,
  .is-checkradio[type="radio"] + label::before {
    top: 0;
    bottom: 0;
    margin: auto 0;
    margin-left: 16px;
  }
`;

export const StyledLevelItem = styled(Level.Item)`
  justify-content: start !important;
  align-content: center;

  border: ${({ theme }) => `1px solid ${L80(theme.colors.grey)}`};
  border-radius: 4px;

  &.checked {
    border: ${({ theme }) => `1px solid ${theme.colors.primary}`};
  }

  &.disabled {
    background-color: ${({ theme }) => L96(theme.colors.grey)};
  }

  // Reset a bulma margin that is automatically applied when there're more than 1 element inside
  // of the level item. This is the case for disabled elements.
  .field:not(:last-child) {
    margin-bottom: 0;
  }

  height: 100%;
`;
